import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as e } from "../../chunks/tslib.es6.js";
import t from "../../TimeExtent.js";
import r from "../../TimeInterval.js";
import { JSONSupport as i } from "../../core/JSONSupport.js";
import { clone as l } from "../../core/lang.js";
import { isSome as o } from "../../core/maybe.js";
import { property as n } from "../../core/accessorSupport/decorators/property.js";
import "../../core/accessorSupport/ensureType.js";
import { reader as a } from "../../core/accessorSupport/decorators/reader.js";
import { subclass as s } from "../../core/accessorSupport/decorators/subclass.js";
import { writer as m } from "../../core/accessorSupport/decorators/writer.js";
import u from "./TimeReference.js";
import { timeUnitKebabDictionary as p } from "../../portal/timeUnitKebabDictionary.js";

var _d;

var c = _d = /*#__PURE__*/function (_i) {
  _inherits(d, _i);

  var _super = _createSuper(d);

  function d(e) {
    var _this;

    _classCallCheck(this, d);

    _this = _super.call(this, e), _this.cumulative = !1, _this.endField = null, _this.fullTimeExtent = null, _this.hasLiveData = !1, _this.interval = null, _this.startField = null, _this.timeReference = null, _this.trackIdField = null, _this.useTime = !0;
    return _this;
  }

  _createClass(d, [{
    key: "readFullTimeExtent",
    value: function readFullTimeExtent(e, r) {
      if (!r.timeExtent || !Array.isArray(r.timeExtent) || 2 !== r.timeExtent.length) return null;
      var i = new Date(r.timeExtent[0]),
          l = new Date(r.timeExtent[1]);
      return new t({
        start: i,
        end: l
      });
    }
  }, {
    key: "writeFullTimeExtent",
    value: function writeFullTimeExtent(e, t) {
      e && o(e.start) && o(e.end) ? t.timeExtent = [e.start.getTime(), e.end.getTime()] : t.timeExtent = null;
    }
  }, {
    key: "readInterval",
    value: function readInterval(e, t) {
      return t.timeInterval && t.timeIntervalUnits ? new r({
        value: t.timeInterval,
        unit: p.fromJSON(t.timeIntervalUnits)
      }) : t.defaultTimeInterval && t.defaultTimeIntervalUnits ? new r({
        value: t.defaultTimeInterval,
        unit: p.fromJSON(t.defaultTimeIntervalUnits)
      }) : null;
    }
  }, {
    key: "writeInterval",
    value: function writeInterval(e, t) {
      if (e) {
        var _r = e.toJSON();

        t.timeInterval = _r.value, t.timeIntervalUnits = _r.unit;
      } else t.timeInterval = null, t.timeIntervalUnits = null;
    }
  }, {
    key: "clone",
    value: function clone() {
      var e = this.cumulative,
          t = this.endField,
          r = this.hasLiveData,
          i = this.interval,
          o = this.startField,
          n = this.timeReference,
          a = this.fullTimeExtent,
          s = this.trackIdField,
          m = this.useTime;
      return new _d({
        cumulative: e,
        endField: t,
        hasLiveData: r,
        interval: i,
        startField: o,
        timeReference: l(n),
        fullTimeExtent: l(a),
        trackIdField: s,
        useTime: m
      });
    }
  }]);

  return d;
}(i);

e([n({
  type: Boolean,
  json: {
    read: {
      source: "exportOptions.timeDataCumulative"
    },
    write: {
      target: "exportOptions.timeDataCumulative"
    }
  }
})], c.prototype, "cumulative", void 0), e([n({
  type: String,
  json: {
    read: {
      source: "endTimeField"
    },
    write: {
      target: "endTimeField",
      allowNull: !0
    }
  }
})], c.prototype, "endField", void 0), e([n({
  type: t,
  json: {
    write: {
      enabled: !0,
      allowNull: !0
    }
  }
})], c.prototype, "fullTimeExtent", void 0), e([a("fullTimeExtent", ["timeExtent"])], c.prototype, "readFullTimeExtent", null), e([m("fullTimeExtent")], c.prototype, "writeFullTimeExtent", null), e([n({
  type: Boolean,
  json: {
    write: !0
  }
})], c.prototype, "hasLiveData", void 0), e([n({
  type: r,
  json: {
    write: {
      enabled: !0,
      allowNull: !0
    }
  }
})], c.prototype, "interval", void 0), e([a("interval", ["timeInterval", "timeIntervalUnits", "defaultTimeInterval", "defaultTimeIntervalUnits"])], c.prototype, "readInterval", null), e([m("interval")], c.prototype, "writeInterval", null), e([n({
  type: String,
  json: {
    read: {
      source: "startTimeField"
    },
    write: {
      target: "startTimeField",
      allowNull: !0
    }
  }
})], c.prototype, "startField", void 0), e([n({
  type: u,
  json: {
    write: {
      enabled: !0,
      allowNull: !0
    }
  }
})], c.prototype, "timeReference", void 0), e([n({
  type: String,
  json: {
    write: {
      enabled: !0,
      allowNull: !0
    }
  }
})], c.prototype, "trackIdField", void 0), e([n({
  type: Boolean,
  json: {
    read: {
      source: "exportOptions.useTime"
    },
    write: {
      target: "exportOptions.useTime"
    }
  }
})], c.prototype, "useTime", void 0), c = _d = e([s("esri.layers.support.TimeInfo")], c);
var v = c;
export { v as default };